export default "__VITE_ASSET__38ff219c__"